import { Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import { isNil } from 'lodash-es';
import React from 'react';

import { Location } from '../../../constants/locationTable';

interface LocationTableItemProps {
  location: Location;
  checked: boolean;
  onSelectChange: (checked: boolean) => void;
  onClick: () => void;
}

function LocationTableItem({ location, checked, onSelectChange, onClick }: LocationTableItemProps) {
  return (
    <TableRow
      key={location.id}
      onClick={onClick}
      hover
      role="checkbox"
      tabIndex={-1}
      sx={{ '&:hover': { cursor: onClick && 'pointer' } }}
    >
      {!isNil(checked) && (
        <TableCell padding="checkbox">
          <Checkbox
            checked={checked}
            onChange={(event) => onSelectChange(event.target.checked)}
            onClick={(event) => event.stopPropagation()}
          />
        </TableCell>
      )}
      <TableCell scope="row" padding="none">
        {location.name}
      </TableCell>
      <TableCell>
        <Typography>{location.address}</Typography>
      </TableCell>
      <TableCell align="right">
        <Typography>{location.poi_id}</Typography>
      </TableCell>
      <TableCell align="right">
        <Typography>{location.latitude}</Typography>
      </TableCell>
      <TableCell align="right">
        <Typography>{location.longitude}</Typography>
      </TableCell>
      <TableCell align="right">
        <Typography>
          {location.radius} {location.bounded_by ? `(${location.bounded_by})` : ''}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography>{location.zipcode}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{location.street}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{location.preceptivity_disabled ? 'Yes' : 'No'}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{location.state}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{location.city}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{location.dma}</Typography>
      </TableCell>
      <TableCell>
        <Typography>{location.congressional_district}</Typography>
      </TableCell>
      <TableCell height={53}>
        <Typography sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 100 }}>
          {location.variables.join(', ')}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default LocationTableItem;
